/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `1` - INDENTED
 * * `3` - FLAT
 */
export enum SubtaskDisplayMode {
  INDENTED = 1,
  FLAT = 3,
}
